import { memo } from 'react';
import { useAnimatedStyle, interpolate } from 'react-native-reanimated';
import { ParallaxListItemProps } from './ParallaxListItem.types';
import Box from '../../Box/Box';

function ParallaxListItem({
  index,
  itemWidth,
  activeItemWidth,
  scrollX,
  children,
  ...rest
}: ParallaxListItemProps) {
  const animatedStyle = useAnimatedStyle(() => {
    const inputRange = [
      (index - 1) * itemWidth,
      index * itemWidth,
      (index + 1) * itemWidth,
    ];

    return {
      width: interpolate(
        scrollX.value,
        inputRange,
        [itemWidth, activeItemWidth, itemWidth],
        'clamp',
      ),
      transform: [
        {
          scale: interpolate(scrollX.value, inputRange, [0.6, 1, 0.6], 'clamp'),
        },
        {
          translateX: interpolate(
            scrollX.value,
            inputRange,
            [30, 0, -30],
            'clamp',
          ),
        },
      ],
      opacity: interpolate(scrollX.value, inputRange, [0.5, 1, 0.5], 'clamp'),
      ...rest,
    };
  });

  return <Box animatedStyle={animatedStyle}>{children}</Box>;
}

export default memo(ParallaxListItem);
